import React from "react";
import { Classes } from "@blueprintjs/core";
import styles from "../../../../../styles/Campaigns/CampaignLogs.module.scss";

const LogRendererLoading = () => {
  return (
    <div className={styles.tabContainer}>
      <div style={{ width: "100%" }}>
        <div className={Classes.SKELETON} style={{ height: "40px", marginTop: "5px" }}></div>
        <div className={Classes.SKELETON} style={{ height: "300px", marginTop: "20px" }}></div>
        <div className={Classes.SKELETON} style={{ height: "300px", marginTop: "20px" }}></div>
      </div>
    </div>
  );
};

export default LogRendererLoading;
